export enum TransactionsRoutePath {
    Transactions = '/transactions'
}
